export const passwordMinLength = 6;
export const passwordMaxLength = 64;
